var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-item"},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"bm-bar"},[_c('Bm4000Bar',{attrs:{"min-particle":_vm.minParticle,"op":{
            title: {
              text: _vm.translateTo('气溶胶多通道粒子数模板', 'device', { num: 4 }),
              textStyle: { fontSize: 14 }
            },
            grid: { top: 55 },
            yAxis: { name: _vm.translateTo('粒子数(个秒)', 'device'), nameGap: 10 },
            xAxis: { name: _vm.translateTo('粒径(μm)', 'device') },
            series: [
              {
                data: [
                  _vm.source.bio2Paror1,
                  _vm.source.bio2Paror2,
                  _vm.source.bio2Paror3,
                  _vm.source.bio2Paror4,
                  _vm.source.bio2Paror5,
                  _vm.source.bio2Paror6,
                  _vm.source.bio2Paror7,
                  _vm.source.bio2Paror8,
                  _vm.source.bio2Paror9,
                  _vm.source.bio2Paror10,
                  _vm.source.bio2Paror11,
                  _vm.source.bio2Paror12,
                  _vm.source.bio2Paror13
                ]
              }
            ]
          }}})],1)]),_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"bm-bar"},[_c('Bm4000Bar',{attrs:{"min-particle":_vm.minParticle,"op":{
            title: {
              text: _vm.translateTo('荧光多通道粒子数模板', 'device', { num: 4 }),
              textStyle: { fontSize: 14 }
            },
            grid: { top: 55 },
            yAxis: { name: _vm.translateTo('粒子数(个秒)', 'device'), nameGap: 10 },
            xAxis: { name: _vm.translateTo('粒径(μm)', 'device') },
            series: [
              {
                data: [
                  _vm.source.bio2Bioor1,
                  _vm.source.bio2Bioor2,
                  _vm.source.bio2Bioor3,
                  _vm.source.bio2Bioor4,
                  _vm.source.bio2Bioor5,
                  _vm.source.bio2Bioor6,
                  _vm.source.bio2Bioor7,
                  _vm.source.bio2Bioor8,
                  _vm.source.bio2Bioor9,
                  _vm.source.bio2Bioor10,
                  _vm.source.bio2Bioor11,
                  _vm.source.bio2Bioor12,
                  _vm.source.bio2Bioor13
                ]
              }
            ]
          }}})],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }